import React, { Dispatch, SetStateAction, useMemo, useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import clsx from 'clsx'

import {
  DropDownIcon,
  FilterIcon,
  LeftArrowIcon,
  RightArrowIcon
} from '../../../iconsV2'

import { CalendarMode, IFilter } from '../../../types'

import Button from '../common/Button'
import Icon from '../common/Icon'
import SelectBox from '../common/SelectBox'
import styles from '../SAPPCalendar.module.css'
import CustomDatePicker from '../CustomDatePicker'
import { Divider } from 'antd'
import { extractMonthYear, extractWeek } from '@utils/index'
import PortalWrapper from '../PortalWrapper'
import { SelectMobile } from '../common/SelectMobile'

interface IHeaderCalendarProps {
  title?: string
  showTeacherName?: boolean
  currentDate: Dayjs
  setCurrentDate: Dispatch<SetStateAction<Dayjs>>
  calendarMode: CalendarMode
  setCalendarMode: Dispatch<SetStateAction<CalendarMode>>
  toggleTurnOnFilter: () => void
  filter: IFilter
  hasFilter: boolean
}

const LMSHeaderCalendarMobile = ({
  title,
  showTeacherName,
  currentDate,
  setCurrentDate,
  calendarMode,
  setCalendarMode,
  toggleTurnOnFilter,
  filter,
  hasFilter
}: IHeaderCalendarProps) => {
  const [openSelectModeMobile, setOpenSelectModeMobile] = useState(false)
  const handleChangeMode = (mode: CalendarMode) => {
    setCalendarMode(mode)
    setCurrentDate(dayjs())
  }

  const handleGoToPrevious = () => {
    setCurrentDate(currentDate.subtract(1, calendarMode))
  }

  const handleGoToNext = () => {
    setCurrentDate(currentDate.add(1, calendarMode))
  }

  const calendarModeOptions = [
    { value: 'month', label: 'Month' },
    { value: 'week', label: 'Week' }
  ]

    // ✅ Tối ưu hóa tính toán tháng/năm với useMemo
    const { month, year } = useMemo(() => {
      return extractMonthYear(dayjs(currentDate.valueOf()))
    }, [currentDate])

    const { startDateDisplay, endDateDisplay, year: weekYear } = useMemo(() => {
      return extractWeek(dayjs(currentDate.valueOf()))
    }, [currentDate])


  return (
    <>
        <PortalWrapper containerId='calendar-root'>
          <div className={styles['header-calendar__mobile']}>
            <div className={styles['header-calendar__controls']}>
            {hasFilter && (
            <div
                className={clsx(
                  styles['hover-item'],
                  {
                    [styles['text-lms-primary']]: filter.isOpen,
                    'pointer-events-none': filter.isOpen,
                  },
                )}
                onClick={toggleTurnOnFilter}
              >
              <FilterIcon />
            </div>
              )}
            </div>
          </div>
        </PortalWrapper>
          <div className="flex justify-between items-center mx-1 mb-5">
            <div className={styles['header-calendar__nav']}>
              <Icon
                icon={<LeftArrowIcon />}
                onClick={handleGoToPrevious}
              />
              <div className={styles['header-calendar__date']} data-testid="header-date">
                {calendarMode === 'week' && (
                  <>
                    <span className={styles['header-calendar__week']}>
                      {startDateDisplay} - {endDateDisplay},{' '}
                    </span>
                    <span className={styles['header-calendar__year']}>{weekYear}</span>
                  </>
                )}
                {calendarMode === 'month' && (
                  <>
                    <span className={styles['header-calendar__month']}>{month}, </span>
                    <span className={styles['header-calendar__year']}>{year}</span>
                  </>
                )}
              </div>
              <Icon icon={<RightArrowIcon />} onClick={handleGoToNext} />
        </div>
          <SelectBox
            open={false}
            value={calendarMode}
            options={calendarModeOptions}
            className="filter-select__mode"
            onClick={() => setOpenSelectModeMobile(true)}
            onChange={(mode) => handleChangeMode(mode as CalendarMode)}
            suffixIcon={<DropDownIcon size={16} />}
          />
          </div>
        <SelectMobile defaultValue={calendarModeOptions[0].value} options={calendarModeOptions} open = {openSelectModeMobile} onClose={() => setOpenSelectModeMobile(false)} onConfirm={(mode) => handleChangeMode(mode as CalendarMode)}/>
      {showTeacherName && (
        <div className={styles['header-calendar__title']}>{title}</div>
      )}
    </>
  )
}

export default LMSHeaderCalendarMobile
